import { ValueOf } from 'type-fest';

import { SHIPPING_METHOD, ShippingMethod } from '@frontend/api';

import {
  PAYMENT_METHOD,
  SHIPPING_CARRIER,
  SHIPPING_GROUPING,
  SHIPPING_TYPE,
} from 'constants/all';

export const SHIPPING_TYPE_LABEL = {
  [SHIPPING_TYPE.PICKUP]: 'No Shipping Fees',
  [SHIPPING_TYPE.CUSTOMER_ACCOUNT]: 'Use Customer Shipping Account',
  [SHIPPING_TYPE.SUPPLIER_ACCOUNT]: {
    [PAYMENT_METHOD.CREDIT_CARD]: 'Charge Me for Shipping',
    [PAYMENT_METHOD.PURCHASE_ORDER]: 'Bill Me at Time of Shipment',
  },
};

export const CUSTOMER_INFO_STEPS = {
  PAYMENT_METHOD: 'payment_method',
  SUPPLIER_FACILITY: 'supplier_facility',
  FACILITY: 'shipping_address',
  BILLING_ADDRESS: 'billing_address',
  SHIPPING_OPTIONS_AND_PRICING_SUMMARY: 'shipping_options_and_pricing_summary',
  PAYMENT_DETAILS: 'payment_details',
};

export const SHIPPING_METHOD_RATES = [
  { method: SHIPPING_METHOD.EARLY_OVERNIGHT, price: 0.0 },
  { method: SHIPPING_METHOD.ONE_DAY, price: 0.0 },
  { method: SHIPPING_METHOD.TWO_DAY, price: 0.0 },
  { method: SHIPPING_METHOD.GROUND, price: 0.0 },
];

export const SHIPPING_CARRIER_LABEL = {
  [SHIPPING_CARRIER.UPS]: 'UPS',
  [SHIPPING_CARRIER.FEDEX]: 'FedEX',
};

export const SHIPPING_METHOD_LABEL = {
  [SHIPPING_METHOD.EARLY_OVERNIGHT]: 'Early AM Overnight',
  [SHIPPING_METHOD.ONE_DAY]: 'Next Day Air',
  [SHIPPING_METHOD.TWO_DAY]: 'Second Day Air',
  [SHIPPING_METHOD.GROUND]: 'Ground',
  [SHIPPING_METHOD.EXPEDITED]: 'Expedited',
} as const satisfies Record<ShippingMethod, string>;

export const SHIPPING_GROUPING_LABEL = {
  [SHIPPING_GROUPING.BULK]: 'All at Once',
  [SHIPPING_GROUPING.BY_LEAD_TIME]: 'When Ready',
};

export const SHIPPING_INFO_TYPES = {
  FACILITY: 'FACILITY',
  NONE: 'NONE',
  ONE_TIME_ADDRESS: 'ONE_TIME_ADDRESS',
};

export type ShippingInfoType = ValueOf<typeof SHIPPING_INFO_TYPES>;

export const BILLING_INFO_TYPES = {
  BILLING_ADDRESS: 'BILLING_ADDRESS',
  NONE: 'NONE',
  ONE_TIME_ADDRESS: 'ONE_TIME_ADDRESS',
};

export const DRAWER_MODES = {
  CREATE: 'create',
  EDIT: 'edit',
} as const;
